module.exports = function () {
	const sliderHomeActu = document.querySelector('.main-carousel');

    $('.sliderHomeActu .main-carousel').flickity({
		setGallerySize: true,
		contain: true,
		prevNextButtons: true,
		pageDots: false,
		wrapAround: true,
		autoPlay: 4000,
		percentPosition: false,
		pageDots: false,
		// adaptiveHeight: true,
	});

	if (sliderHomeActu) {

		const blocs = sliderHomeActu.querySelectorAll('.carousel-cell');
		const prevButton = sliderHomeActu.querySelector('.previous');
		const nextButton = sliderHomeActu.querySelector('.next');

		if (blocs.length > 1) {

			if (prevButton) {
				prevButton.addEventListener('click', function () {
					$('.fs-carousel').flickity('previous');
				});
			}

			if (nextButton) {
				nextButton.addEventListener('click', function () {
					$('.fs-carousel').flickity('next');
				});
			}

		} else {

			if (prevButton) {
				prevButton.style.display = 'none';
			}

			if (nextButton) {
				nextButton.style.display = 'none';
			}
		}

		// positionnig title width slides text
		// Helper function to get an element's exact position

		const firstBloc = sliderHomeActu.querySelector('.carousel-cell.is-selected');
		const title = document.querySelector('.sliderHomeActu .na-title');
		const textBloc = firstBloc.querySelector('.sliderHomeActu__bloc__text');
		var x = getPosition(textBloc);

		function getPosition(el) {
			var xPos = 0;

			while (el) {
				if (el.tagName == "BODY") {
					// deal with browser quirks with body/window/document and page scroll
					var xScroll = el.scrollLeft || document.documentElement.scrollLeft;

					xPos += (el.offsetLeft - xScroll + el.clientLeft);
				} else {
					// for all other non-BODY elements
					xPos += (el.offsetLeft - el.scrollLeft + el.clientLeft);
				}

				el = el.offsetParent;
			}
			return xPos;
		}


		// deal with the page getting resized or scrolled
		// window.addEventListener("scroll", updateTitlePosition, false);
		// window.addEventListener("resize", updateTitlePosition, false);

		updateTitlePosition();

		function updateTitlePosition() {
			if (window.innerWidth < 1200) {
				x -= 19;
			} else {
				x -= 5;
			}
			title.setAttribute("style", 'left: '+x+'px;');
		}
	}
}
